<script>
import Cookies from 'js-cookie';
import auth from '@/auth';
import { ROUTE_WECHAT_AUTHORIZE, ROUTE_TRAINER_LIST } from '@/router/names';

export default {
    created() {
        const { redirect } = this.$route.query;
        if (auth.loggedIn()) {
            const finalRedirect = redirect || Cookies.get('redirect') || { name: ROUTE_TRAINER_LIST };

            Cookies.remove('redirect');
            this.$router.replace(finalRedirect);
            return;
        }

        if (redirect) {
            Cookies.set('redirect', redirect, { expires: 7 });
        }
        this.$router.replace({
            name: ROUTE_WECHAT_AUTHORIZE,
        });
    },
    render() {
        return null;
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/login/Login.vue